import apiClient from "./apiClient";

/* CREATE SERVICE */
export const createService = async (serviceData) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.post(
    "admin/services", // ✅ FIXED
    serviceData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        
      }
    }
  );

  return response.data;
};

/* GET ALL SERVICES */
export const getAllServices = async () => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    "admin/services", // ✅ FIXED
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};



export const toggleServiceStatus = async (serviceId) => {
    const token = localStorage.getItem("token");

    const response = await apiClient.patch(
        `admin/services/${serviceId}/toggle-active`,
        {},
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.data; // updated service
};


/* GET SERVICE BY ID */
export const getServiceById = async (id) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    `admin/services/${id}`, // ✅ FIXED
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

/* GET PARENT SERVICES */
export const getParentServices = async () => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    "admin/services",
    { headers: { Authorization: `Bearer ${token}` } }
  );

  return response.data.filter(s => s.parentServiceId === null);
};

export const updateService = async (serviceId, payload) => {
    const token = localStorage.getItem("token");

    const response = await apiClient.put(
        `admin/services/${serviceId}`,
        payload,
        {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    );

    return response.data;
};

/* GET ALL SERVICE GROUPS */
export const getAllServiceGroups = async () => {
  const token = localStorage.getItem("token");

  const response = await apiClient.get(
    "ServiceGroups",
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

/* CREATE SERVICE GROUP */
export const createServiceGroup = async (data) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.post(
    "ServiceGroups",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

/* UPDATE SERVICE GROUP */
export const updateServiceGroup = async (id, data) => {
  const token = localStorage.getItem("token");

  const response = await apiClient.put(
    `ServiceGroups/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;
};

export const assignServiceToGroup = async (serviceId, data) => {
  try {
    const token = localStorage.getItem("token");

    const response = await apiClient.put(
      `admin/services/${serviceId}/assign-group`,
      data,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response.data;

  } catch (error) {
    console.error("Error assigning service to group:", error);
    throw error;
  }
};


export const createServiceApplication = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("No token found");

    const response = await apiClient.post(
      "ServiceApplication",   // ← confirm this matches your route (with or without /api prefix)
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // REMOVE THIS LINE COMPLETELY
          'Content-Type': 'multipart/form-data'
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Service application failed:", error);
    
    // ← Very important: log the full server response if available
    if (error.response) {
      console.log("Status:", error.response.status);
      console.log("Server error details:", error.response.data);
    } else if (error.request) {
      console.log("No response received – network/cors issue?", error.request);
    } else {
      console.log("Axios setup error:", error.message);
    }
    
    throw error;
  }
};

export const getAllServiceApplications = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("No token found");

    const response = await apiClient.get(
      "ServiceApplication", // must match your controller route
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Fetching service applications failed:", error);

    if (error.response) {
      console.log("Status:", error.response.status);
      console.log("Server error details:", error.response.data);
    } else if (error.request) {
      console.log("No response received – network/cors issue?", error.request);
    } else {
      console.log("Axios setup error:", error.message);
    }

    throw error;
  }
};

export const getServiceApplicationById = async (id) => {
    const res = await apiClient.get(`ServiceApplication/${id}`);
    return res.data;
};

export const updateApplicationStatus = async (applicationId, data) => {

    const response = await apiClient.put(
        `ServiceApplication/${applicationId}/status`,
        data,
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    );

    return response.data;
};